// @constants
const actionTypes = require('constants/RAConstants/actionTypes');

const updateObjective = title => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_DESCRIPTION,
    payload: {
        title,
    },
});

const setObjectiveAmount = amount => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_AMOUNT,
    payload: {
        amount,
    },
});

const setObjectiveEndDate = date => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_END_DATE,
    payload: {
        date,
    },
});

const setInitialContributionAmount = investment => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_INITIAL_CONTRIBUTION_AMOUNT,
    payload: {
        investment,
    },
});

const setRecurringContributionAmount = amount => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_RECURRING_CONTRIBUTION_AMOUNT,
    payload: {
        amount,
    },
});

const setPeriodicity = periodicity => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_PERIODICITY,
    payload: {
        periodicity,
    },
});

const setContributionDay = day => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_CONTRIBUTION_DAY,
    payload: {
        day,
    },
});

const setSelectedStrategy = id => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_SELECTED_STRATEGY,
    payload: id,
});

const getSimulation = () => (dispatch, getState) => {
    const immSimulation = getState().raSimulation.get('simulation');
    dispatch({
        type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_DATA_FROM_SIMULATION,
        payload: immSimulation,
    });
};

export default {
    getSimulation,
    setContributionDay,
    setInitialContributionAmount,
    setObjectiveAmount,
    setObjectiveEndDate,
    setPeriodicity,
    setRecurringContributionAmount,
    setSelectedStrategy,
    updateObjective,
};
